export default __webpack_public_path__ + "static/oliver-3dac7f296ed66e621dd66faeebda58ae.png";